import React from 'react';
import GuideLife from './GuideLife';
import './Guide.scss';

const Guide = () => {
  return (
    <div className="Guide">
      <GuideLife />
    </div>
  );
};

export default Guide;
